import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from '../../../node_modules/@mui/system/index';
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';

const WhatisCdp = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PageHeader
                        title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className="gri-header">
                    <NavigationButtons imageKey="CDP" title={"CDP Reporting"} activeStep={0} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box
                    sx={{
                        borderRadius: '8px',
                        padding: '24px',
                        top: '226px',
                        left: '75px',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: '#2E7D32',
                            mb: 3,
                            fontFamily: 'DM Sans',
                            fontSize: '40px',
                            lineHeight: '38px',
                        }}
                    >
                        The global standards for sustainability<br /> impacts
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                        <Typography
                            component="h4"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 800,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 1,
                            }}
                        >
                            What is CDP? — Brief introduction
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                            }}
                        >
                            CDP (Carbon Disclosure Project) is a globally recognized non-profit organization that operates an environmental disclosure and data reporting platform, encouraging companies, cities, states, and regions to transparently measure, disclose, manage, and reduce their environmental impacts. Through its standardized questionnaires on climate change, water security, and deforestation, CDP collects self-reported data on greenhouse gas emissions, climate-related risks, mitigation strategies, and supply chain sustainability. This information is used by investors, customers, and policymakers to assess environmental performance and drive improvements. CDP plays a critical role in advancing corporate environmental accountability, enhancing sustainability leadership, and supporting global climate goals and the transition to a low-carbon, resilient economy.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <a
                        href="https://www.cdp.net/en"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                    >
                        <CustomButton title="Access to full CDP Disclosure" />
                    </a>
                </Box>
            </Grid>
        </Grid>
    );
};

export default WhatisCdp;